import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIDataProvider, ApiPaths, TApiResponse } from '../../api';
import { IDiagnostic, IRecommendation } from '.';
import { IUser } from '../UserSlice';

interface ICreateDiagnostic {
  user: string;
  submission: string;
  email?: string;
  fullName?: string;
  phoneNumber?: string;
  grade: string;
  curriculum: string;
  subject: string;
  subTopicId: string;
  country: string;
  course?: string;
}

interface IShareParent {
  diagnosticId: string;
  parentName: string;
  parentPhoneNumber: string;
}

interface ICreateDiagnosticResponse {
  diagnostic: IDiagnostic;
  user: IUser;
}

const apiDataProvider = new APIDataProvider();

export const createDiagnostic = createAsyncThunk(
  'diagnostic/create',
  async (data: ICreateDiagnostic) => {
    const response = await apiDataProvider.post<
      TApiResponse<ICreateDiagnosticResponse>
    >(`${ApiPaths.diagnostics}/create`, data);

    return response.data;
  }
);

export const getDiagnosticById = createAsyncThunk(
  'diagnostic/get',
  async (id: string) => {
    const response = await apiDataProvider.get<TApiResponse<IDiagnostic>>(
      `${ApiPaths.diagnostics}/${id}`
    );

    return response.data;
  }
);

export const getDiagnosticBySubmissionId = createAsyncThunk(
  'diagnostic/getBySubmissionId',
  async (id: string) => {
    const response = await apiDataProvider.get<TApiResponse<IDiagnostic>>(
      `${ApiPaths.diagnostics}/submission/${id}`
    );

    return response.data;
  }
);

export const getDiagnosticBySubTopicId = createAsyncThunk(
  'diagnostic/getBySubTopicId',
  async (data: { subTopicId: string; userId: string }) => {
    const response = await apiDataProvider.get<TApiResponse<IDiagnostic>>(
      `${ApiPaths.diagnostics}/subTopic/subTopic?userId=${data.userId}&subTopicId=${data.subTopicId}`
    );

    return response.data;
  }
);

export const getRecommendation = createAsyncThunk(
  'diagnostic/getRecommendation',
  async (data: { subject: string; grade: string }) => {
    const response = await apiDataProvider.get<TApiResponse<IRecommendation>>(
      `${ApiPaths.diagnostics}/recommendation?subject=${data.subject}&grade=${data.grade}`
    );

    return response.data;
  }
);

export const shareWithParent = createAsyncThunk(
  'diagnostic/shareWithParent',
  async (data: IShareParent) => {
    const response = await apiDataProvider.post<TApiResponse<IDiagnostic>>(
      `${ApiPaths.diagnostics}/shareWithParent`,
      data
    );

    return response.data;
  }
);

export const requestCallback = createAsyncThunk(
  'diagnostic/requestCallback',
  async (dealId: string) => {
    const response = await apiDataProvider.get<TApiResponse<IRecommendation>>(
      `${ApiPaths.diagnostics}/requestCallback/${dealId}`
    );

    return response.data;
  }
);

export const getDiagnosticByCourseId = createAsyncThunk(
  'diagnostic/getByCourseId',
  async (id: string) => {
    const response = await apiDataProvider.get<TApiResponse<IDiagnostic>>(
      `${ApiPaths.diagnostics}/course/${id}`
    );

    return response.data;
  }
);
